<template>
  <div class="text-center">
    <v-dialog max-width="600px" v-model="dialog" transition="dialog-bottom-transition" overlay-opacity="0.9" overlay-color="black">
      <!-- Activator ist jetzt NUR der Button, genau wie bei EnterHolidays -->
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon large v-bind="attrs" v-on="on">
          <v-icon color="white">mdi-clock-start</v-icon>
        </v-btn>
      </template>

      <v-card class="rounded-xl" color="#1E1E1E">
        <v-toolbar flat color="transparent" class="pt-2 border-bottom-light">
          <v-toolbar-title class="text-h6 font-weight-bold white--text pl-2">
            <v-icon color="#00963f" class="mr-2">mdi-clock-start</v-icon> Schichtwünsche
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" color="grey"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="pa-0">
          <v-tabs v-model="tab" background-color="transparent" grow slider-color="#00963f" centered>
            <v-tab class="font-weight-bold text-caption white--text">Meine Wünsche</v-tab>
            <v-tab class="font-weight-bold text-caption white--text">Neuer Wunsch</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" class="transparent-bg mt-4" touchless>
            <!-- LISTE -->
            <v-tab-item>
              <div v-if="sortedWishes.length === 0" class="pa-10 text-center">
                <v-icon size="64" color="#333" class="mb-4">mdi-calendar-clock</v-icon>
                <div class="grey--text">Keine offenen Schichtwünsche.</div>
                <v-btn text color="#00963f" small @click="tab = 1" class="mt-2">Jetzt einen erstellen</v-btn>
              </div>

              <v-list v-else two-line color="transparent" class="px-2" style="max-height: 400px; overflow-y: auto">
                <v-card v-for="wish of sortedWishes" :key="wish._id" class="mb-3 rounded-lg border-light card-hover" color="#252525" elevation="0">
                  <div class="d-flex align-center pa-3">
                    <v-sheet color="#333" class="rounded-lg d-flex flex-column align-center justify-center mr-4" width="50" height="50">
                      <span class="font-weight-bold white--text text-h6 line-height-1">{{ $moment(wish.day).format("DD") }}</span>
                      <span class="text-uppercase grey--text text--lighten-1 text-xs">{{ $moment(wish.day).format("MMM") }}</span>
                    </v-sheet>

                    <div class="flex-grow-1 overflow-hidden">
                      <div class="d-flex align-center">
                        <v-icon x-small :color="getTypeColor(wish.type)" class="mr-1">{{ getTypeIcon(wish.type) }}</v-icon>
                        <div class="text-subtitle-2 white--text text-truncate">
                          {{ getTypeLabel(wish.type) }}
                        </div>
                      </div>
                      <div class="text-caption grey--text text-truncate">
                        {{ wish.comment || "Keine Bemerkung" }}
                      </div>
                    </div>

                    <div class="text-right d-flex flex-column align-end">
                      <v-chip
                        small
                        label
                        :color="wish.status === 'open' ? 'orange' : wish.status === 'accepted' ? '#00963f' : 'red'"
                        text-color="white"
                        class="font-weight-bold mb-1">
                        {{ mapStatus[wish.status] }}
                      </v-chip>

                      <v-btn icon x-small v-if="wish.status === 'open'" @click="cancelWish(wish._id)" color="grey darken-1">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-list>
            </v-tab-item>

            <!-- ERSTELLEN -->
            <v-tab-item>
              <v-stepper v-model="stepperModel" vertical class="transparent elevation-0 pb-4">
                <v-stepper-step :complete="stepperModel > 1" step="1" color="#00963f">
                  <span class="white--text">Datum wählen</span>
                  <small v-if="stepperModel > 1" class="primary-green--text font-weight-bold">{{ $moment(day).format("DD.MM.YYYY") }}</small>
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-date-picker
                    v-model="day"
                    no-title
                    scrollable
                    color="#00963f"
                    full-width
                    dark
                    class="rounded-lg elevation-0 mb-4 border-light"></v-date-picker>
                  <v-btn color="#00963f" depressed class="rounded-lg white--text" @click="stepperModel = 2">Weiter</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="stepperModel > 2" step="2" color="#00963f">
                  <span class="white--text">Schichtart wünschen</span>
                </v-stepper-step>

                <v-stepper-content step="2">
                  <v-item-group v-model="type" mandatory class="mb-6">
                    <v-row dense>
                      <v-col cols="4" v-for="opt in shiftOptions" :key="opt.value">
                        <v-card
                          :color="type === opt.value ? '#00963f' : '#333'"
                          @click="type = opt.value"
                          class="py-4 text-center rounded-lg cursor-pointer transition-swing d-flex flex-column align-center"
                          elevation="0"
                          height="100">
                          <v-icon class="mb-2" :color="type === opt.value ? 'white' : 'grey'">{{ opt.icon }}</v-icon>
                          <div class="text-caption font-weight-bold" :class="type === opt.value ? 'white--text' : 'grey--text'">{{ opt.text }}</div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-item-group>
                  <v-btn text color="grey" @click="stepperModel -= 1">Zurück</v-btn>
                  <v-btn color="#00963f" depressed class="rounded-lg white--text ml-2" @click="stepperModel = 3">Weiter</v-btn>
                </v-stepper-content>

                <v-stepper-step :complete="stepperModel > 3" step="3" color="#00963f">
                  <span class="white--text">Bemerkung (Optional)</span>
                </v-stepper-step>

                <v-stepper-content step="3">
                  <v-textarea
                    v-model="comment"
                    placeholder="Grund oder Zeitpräferenz (optional)"
                    solo
                    flat
                    background-color="#333"
                    dark
                    rows="3"
                    class="rounded-lg"
                    hide-details></v-textarea>
                  <div class="d-flex mt-4">
                    <v-btn text color="grey" @click="stepperModel -= 1">Zurück</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :loading="loading" color="#00963f" depressed class="rounded-lg white--text px-6 shadow-glow" @click="saveWish">
                      Wunsch absenden <v-icon right small>mdi-send</v-icon>
                    </v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/api"

export default {
  name: "EnterShiftWishes",
  data() {
    return {
      loading: false,
      wishes: [],
      mapStatus: {
        open: "Offen",
        accepted: "Genehmigt",
        rejected: "Abgelehnt",
      },
      shiftOptions: [
        { value: "morning", text: "Morgen", icon: "mdi-weather-sunset-up" },
        { value: "intermediate", text: "Zwischen", icon: "mdi-white-balance-sunny" },
        { value: "late", text: "Spät", icon: "mdi-weather-night" },
      ],
      tab: null,
      stepperModel: 1,
      day: this.$moment().add(1, "days").format("YYYY-MM-DD"),
      dialog: false,
      type: "morning",
      comment: "",
    }
  },
  async created() {
    this.fetchData()
  },
  watch: {
    dialog(val) {
      if (val) this.fetchData()
    },
  },
  computed: {
    sortedWishes() {
      const w = [...this.wishes]
      return w.sort((a, b) => new Date(b.day) - new Date(a.day))
    },
  },
  methods: {
    async fetchData() {
      try {
        this.wishes = await api.fetchShiftWishEntriesEmployee()
      } catch (e) {
        console.log(e)
      }
    },
    getTypeLabel(type) {
      const opt = this.shiftOptions.find((o) => o.value === type)
      return opt ? opt.text : type
    },
    getTypeIcon(type) {
      const opt = this.shiftOptions.find((o) => o.value === type)
      return opt ? opt.icon : "mdi-help"
    },
    getTypeColor(type) {
      if (type === "morning") return "orange lighten-2"
      if (type === "intermediate") return "yellow lighten-2"
      if (type === "late") return "blue lighten-2"
      return "grey"
    },
    async cancelWish(id) {
      if (!confirm("Möchtest du diesen Wunsch zurückziehen?")) return
      try {
        await api.changeShiftWishStatus({ _id: id, status: "rejected" })
        this.fetchData()
        this.$toast.success("Wunsch zurückgezogen")
      } catch (e) {
        this.$toast.error("Fehler beim Abbrechen")
      }
    },
    async saveWish() {
      this.loading = true
      try {
        let newEntry = {
          day: this.day,
          type: this.type,
          comment: this.comment,
        }
        await api.createShiftWishEntryEmployee(newEntry)

        this.$toast.success("Schichtwunsch gesendet")
        this.tab = 0
        this.comment = ""
        this.type = "morning"
        this.stepperModel = 1
        this.fetchData()
      } catch (e) {
        console.log(e)
        this.$toast.error("Fehler beim Speichern")
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.transparent-bg {
  background: transparent !important;
}
.text-xs {
  font-size: 10px;
}
.line-height-1 {
  line-height: 1;
}
.border-light {
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.border-bottom-light {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.primary-green--text {
  color: #00963f !important;
}
.shadow-glow {
  box-shadow: 0 0 15px rgba(0, 150, 63, 0.4) !important;
}
.card-hover:hover {
  background: rgba(50, 50, 50, 0.5) !important;
}
</style>
